import {
  SHOW_PREVIEW_CV,
  HIDE_PREVIEW_CV,
} from './types';


const initialState = {
  showcvdialog: false,
  cvpreviewkey: 0
};

const getters = {
  getPreviewCVMenuStatus: state => state.showcvdialog,
};

const actions = {
  showPreviewCVMenu({ commit }) {
    console.log('SHOW_PREVIEW_CV');
    commit(SHOW_PREVIEW_CV);
  },
  hidePreviewCVMenu({ commit }, { val }) {
    // NOTER le paramètre 'val' nécessaire ici et appeller sur le component
    console.log('HIDE_PREVIEW_CV');
    commit(HIDE_PREVIEW_CV, val);
  }
};

const mutations = {
  [SHOW_PREVIEW_CV](state) {
    state.showcvdialog = true;
    state.cvpreviewkey = state.cvpreviewkey + 1;
  },
  [HIDE_PREVIEW_CV](state, val) {
    /* Paramètre 'val' Nécessaire comme setter sur v-model lorsque
       Voir notes sur component CvPreviewCompo.vue
    */
    state.showcvdialog = val;
    // state.cvpreviewkey = state.cvpreviewkey + 1;
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};